import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const LeftRight: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m515.29 408.31-20.58-21.82 123.88-116.79-119.31-121.8 21.44-21 140.69 143.66z' />
    <path d='m365 77.75h30v380h-30z' transform='matrix(.00191986 -.99999816 .99999816 .00191986 111.55 647.26)' />
    <path d='m120 282.4h90s0-30 0-30h-60c-16.57 0-30 13.43-30 30z' />
    <path d='m264.71 658.31-146.12-137.75 140.69-143.66 21.44 21-119.31 121.8 123.88 116.79z' />
    <path d='m210 502.75h380v30h-380z' transform='matrix(.99999848 -.00174533 .00174533 .99999848 -.94 .73)' />
    <path d='m660 532.4h-90s0-30 0-30h60c16.57 0 30 13.43 30 30z' />
  </IconBase>
));

LeftRight.displayName = 'LeftRight';

export default LeftRight;
